
import AuthorList from '@/data/author/view/list.vue'

const list = {
  path: '/author',
  name: 'author-list',
  component: AuthorList
}

export default [list]
